/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   popularAmenitiesTracking.ts
 */

import { getUser } from '@zcode-ui/web-zumper-global-state'
import { event } from '@zcode/integrations'
import { getCurrentLocation } from '../../../../inspectors'
import type { Dispatch, GetState } from '../../../../module/types'
import {
  POPULAR_AMENITY_TRAKTOR_FILTER_APPLIED,
  POPULAR_AMENITY_TRAKTOR_KEY,
  POPULAR_AMENITY_TRAKTOR_RESULTS_SHOWN,
} from './constants'

export const trackFilterApplied =
  (filterApplied: string) => (dispatch: Dispatch, getState: GetState) => {
    const state = getState()
    const user = getUser(state)
    const location = getCurrentLocation(state)

    return dispatch(
      event({
        name: POPULAR_AMENITY_TRAKTOR_KEY,
        props: {
          type: POPULAR_AMENITY_TRAKTOR_FILTER_APPLIED,
          filterApplied,
        },
        user,
        location,
      })
    )
  }

export const trackFilterCount =
  (filterResults: number) => (dispatch: Dispatch, getState: GetState) => {
    const state = getState()
    const user = getUser(state)
    const location = getCurrentLocation(state)

    return dispatch(
      event({
        name: POPULAR_AMENITY_TRAKTOR_KEY,
        props: {
          type: POPULAR_AMENITY_TRAKTOR_RESULTS_SHOWN,
          filterResults,
        },
        user,
        location,
      })
    )
  }
